import React, { useState } from "react";
import { Table, Button, Modal } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { formatDateTime } from "../../helpers/date";

const AdminAuditLogItem = ({ auditLog, loading }) => {
  const [messageData, setMessageData] = useState("");
  const [isMessageVisible, setIsMessageVisible] = useState(false);

  const showChanges = (text) => {
    let courierResponse = JSON.stringify(text, null, 2);
    setMessageData(courierResponse);
    setIsMessageVisible(true);
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "objectId",
      width: 80,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: 100,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      width: 90,
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
    {
      title: "Updated By",
      dataIndex: ["updatedBy", "username"],
      width: 90,
    },
    {
      title: "Changes",
      dataIndex: "changes",
      align: "center",
      width: 50,
      render: (text) =>
        text ? (
          <Button
            icon={<InfoCircleOutlined />}
            shape="circle"
            size="small"
            type="primary"
            onClick={() => showChanges(text)}
          ></Button>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <div className="D">
      <Table
        rowKey="objectId"
        pagination={false}
        columns={columns}
        dataSource={auditLog}
        loading={loading}
      />
      <Modal
        title="Message"
        visible={isMessageVisible}
        onOk={() => setIsMessageVisible(false)}
        onCancel={() => setIsMessageVisible(false)}
      >
        <pre>{messageData}</pre>
      </Modal>
    </div>
  );
};

export default AdminAuditLogItem;
